import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function DetailedServicesSection() {
  const {
    t
  } = useLanguage();
  const services = [{
    number: '01',
    title: t('services.1.title'),
    description: t('services.1.desc'),
    imagePosition: 'left'
  }, {
    number: '02',
    title: t('services.2.title'),
    description: t('services.2.desc'),
    imagePosition: 'right'
  }, {
    number: '03',
    title: t('services.3.title'),
    description: t('services.3.desc'),
    imagePosition: 'left'
  }];
  return <section className="bg-[#0A0A0A] text-white py-16" data-id="element-94">
      <div className="max-w-[1800px] mx-auto" data-id="element-95">
        {services.map((service, index) => <div key={index} className="flex flex-col lg:grid lg:grid-cols-2 gap-8 lg:gap-12 items-center py-12 lg:py-16 px-6 lg:px-12 border-t border-white/5" data-id="element-96">
            {/* Mobile: Title first */}
            <div className="lg:hidden w-full order-1" data-id="element-97">
              <span className="text-[10px] tracking-[0.4em] text-[#B8956C] mb-4 font-light block" data-id="element-98">
                {service.number}
              </span>
              <h3 className="font-serif text-3xl mb-4 leading-tight font-light tracking-wide" data-id="element-99">
                {service.title}
              </h3>
            </div>

            {/* Image - order 2 on mobile */}
            <div className={`relative bg-[#1A1A1A] aspect-[4/3] overflow-hidden group w-full order-2 ${service.imagePosition === 'right' ? 'lg:order-2' : 'lg:order-1'}`} data-id="element-100">
              <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-br from-[#1A1A1A] to-[#0A0A0A] group-hover:scale-105 transition-transform duration-1000" data-id="element-101">
                <span className="font-serif italic text-xl text-gray-700 opacity-40" data-id="element-102">
                  Service Image
                </span>
              </div>
            </div>

            {/* Content - order 3 on mobile */}
            <div className={`relative flex flex-col justify-center w-full order-3 ${service.imagePosition === 'right' ? 'lg:order-1' : 'lg:order-2'}`} data-id="element-103">
              {/* Desktop: Show title here */}
              <div className="hidden lg:block" data-id="element-104">
                <span className="text-[10px] tracking-[0.4em] text-[#B8956C] mb-6 font-light block" data-id="element-105">
                  {service.number}
                </span>
                <h3 className="font-serif text-3xl lg:text-4xl mb-6 leading-tight font-light tracking-wide" data-id="element-106">
                  {service.title}
                </h3>
              </div>

              <div className="w-12 h-[1px] bg-[#B8956C]/50 mb-6 lg:mb-8" data-id="element-107"></div>

              <p className="text-gray-400 font-light leading-relaxed text-base mb-8 lg:mb-10 max-w-lg" data-id="element-108">
                {service.description}
              </p>

              <button className="inline-flex items-center gap-4 text-[11px] tracking-[0.3em] uppercase border-b border-[#B8956C]/50 pb-3 hover:border-[#B8956C] transition-colors w-fit group font-light" data-id="element-109">
                {t('services.details')}
                <ArrowRight size={16} className="group-hover:translate-x-2 transition-transform duration-300" data-id="element-110" />
              </button>
            </div>
          </div>)}
      </div>
    </section>;
}